/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Copy_Dialogue_Track_2Inputs */



/**
* | output |
* | --- |
* | "Copy Dialogue From Track 2" |
*
* @param {Event_Group_Options_Copy_Dialogue_Track_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_copy_dialogue_track_2 = /** @type {((inputs?: Event_Group_Options_Copy_Dialogue_Track_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Copy_Dialogue_Track_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier les dialogues de la piste 2")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog von Spur 2 kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia il dialogo dalla traccia 2")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать диалог со второй дорожки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar diálogo de la pista 2")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从音轨 2 复制对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラック2からダイアログをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक 2 से संवाद कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar diálogo da faixa 2")
	return /** @type {LocalizedString} */ ("Copy Dialogue From Track 2")
});